const types = {
  SET_INCOMPLETE_CASES_LOADING: "SET_INCOMPLETE_CASES_LOADING",
  SET_INCOMPLETE_CASES_COUNT: "SET_INCOMPLETE_CASES_COUNT",
  SET_INCOMPLETE_CASES: "SET_INCOMPLETE_CASES",
};

export default types;
